/*
 *@Description: 指令-阻止原生滑动 v-stop-native-touch
 *@params:<div v-stop-native-touch="200"></div>
 */
import type { Directive, DirectiveBinding } from 'vue';
import { jsbTouchEvent } from '@q-front-npm/jsbridge';

const stopNativeTouch: Directive = {
    bind(el: HTMLElement, binding: DirectiveBinding<number>) {
        let inertiaTimeout: any = null;
        function onTouchStart(e: TouchEvent) {
            clearTimeout(inertiaTimeout);
            jsbTouchEvent(true);
        }
        function onTouchEnd(e: TouchEvent) {
            // 设置一个超时，用来检测惯性滑动是否结束
            inertiaTimeout = setTimeout(() => {
                jsbTouchEvent(false);
            }, binding.value || 500); // 超时时间为500毫秒
        }

        el.addEventListener('touchstart', onTouchStart);
        el.addEventListener('touchend', onTouchEnd);
        el.addEventListener('touchcancel', onTouchEnd);
    },
};

export default stopNativeTouch;
